import React from 'react';
import DeviceIcons from '../deviceList/DeviceIcons';
import LastEventInfo from './LastEventInfo';
import DeviceStatuses from '../deviceList/DeviceStatuses';
import ControllerAlerts from '../features/Devices/controller/ControllerAlerts';

const Controller = ({ device }) => {
  return (
    <div className="bg-white first:rounded-tl-3xl cursor-pointer rounded-3xl last:rounded-br-3xl p-5 border-l select-none tap-highlight-transparent flex flex-col justify-between h-full">
      <div className="flex gap-x-4 items-center">
        <DeviceIcons device={device} />
        <div className="col-span-5">
          <p className="truncate">{device?.type?.name}</p>
          <p className="truncate text-sm text-gray-400">{device?.serial_number}</p>
        </div>
        <ControllerAlerts device={device} />
      </div>
      <div className="mt-2 flex-1">
        <div className="truncate text-xs text-gray-400">
          <LastEventInfo device={device} />
        </div>
      </div>
      <div className={'flex items-center justify-between gap-x-2'}>
        <div>
          <DeviceStatuses device={device} style="truncate text-gray-800 col-span-4" icon={false} />
        </div>
      </div>
    </div>
  );
};
export default Controller;
